var AdminRosterRouting = require("lib/routing/AdminRosterRouting")
var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var StudentListDropdownDisplay = require("components/org/StudentListDropdownDisplay");
import { provideLocationState } from "components/utility/hoc/LocationState";

import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
@provideLocationState(AdminRosterRouting.getRouteState)

@connect(
	(state, props) => {
		var studentLists = RosterSelectors.studentLists({ state  });
		return { studentLists };
	},
	(dispatch, propTypes) => ({
		populateData: () => {
			return dispatch(RosterActions.fetchStudentLists({
				embeds: ["student_list.admins", "student_list.students", "student_list.primary_admin", "student.primary_student_list_id"]
			}))
		}
	})
)
@providePopulateData({ waitForLoad: true })

class AdminRosteringPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		// var studentList = _.sortBy(this.props.studentLists, function(studentList) {
		// 	return studentList.students.length * -1;
		// })[0]

		// this.state = { currentStudentList: this.props.studentLists[0] }
	}

	// renderStudentLists() {
	// 	_.each(this.props.studentLists, (studentList) => {

	// 		var studentSelectors = [];
	// 		var allSelected = true;

	// 		_.each(this.props.studentsByStudentListID[studentList.id], (student) => {
	// 			if (effectiveIDs.has(student.id)) {
	// 				var isSelected = true;
	// 				selectedNames.push(student.display_name);
	// 			} else {
	// 				var isSelected = false;
	// 				allSelected = false;
	// 			}
	// 			studentSelectors.push(
	// 				<ButtonDropdownOption key={ "s-" + student.id }
	// 					preventCollapse={ true } className="studentOp"
	// 					onClick={ this.toggleStudent.bind(this, student, isSelected) }>

	// 					<input type="checkbox" checked={ isSelected } onChange={ () => {} } />
	// 					{" "}{ student.display_name }
	// 				</ButtonDropdownOption>
	// 			);
	// 		});

	// 		selectors.push(
	// 			<ButtonDropdownOption key={ "sl-" + studentList.id }
	// 				preventCollapse={ true } className="studentListOp" 
	// 				onClick={ this.toggleStudentList.bind(this, studentList, allSelected) }>

	// 				<input type="checkbox" checked={ allSelected } onChange={ () => {} } />
	// 				{" "}{ studentList.name }
	// 			</ButtonDropdownOption>
	// 		);

	// 		selectors = selectors.concat(studentSelectors);

	// 	});
	// }

	studentListSubject() {
		return (this.props.subjectType == AdminRosterRouting.SUBJECTS.STUDENTS) && this.props.subjectID;
	}

	activeStudentList() {
		if (this.studentListSubject()) {
			return _.findWhere(this.props.studentLists, { id: this.props.subjectID })
		}
	}

	changeSubject(activeView, studentListID) {
		$wr.redirect(AdminRosterRouting.getPath({
			activeView: this.props.locationState.activeView,
			studentListID: studentListID
		}));
	}

	studentListChange(studentList) {
		this.changeSubject(this.props.locationState.activeView, studentList.id);
	}

	getStudentLists() {
		return _.select(this.props.studentLists, (studentList) => {
			return studentList.students.length > 0;
		});
	}

	render() {
		var { activeView, studentListID } = this.props.locationState;
		console.log(this.props.studentLists)

		var sortedStudentLists = $wr.sortByName(this.props.studentLists, "studentList");
		var studentLists = this.getStudentLists()

		if (studentLists.length == 0) {
			return this.renderEmptyState();
		}

		studentLists = $wr.sortByName(studentLists, "studentList")

		var allStudentLists = { id: ALL_CLASSES_FAKE_ID, name: "All Classes" };
		var studentListsClone = _.clone(studentLists)
		studentListsClone.unshift(allStudentLists);


		var dropdownDisplay = ( 
			<div>
				<StudentListDropdownDisplay studentLists={ studentListsClone } 
					currentStudentList={ this.activeStudentList() }
					onChange={ this.studentListChange } 
					dropdownDisplay={ "link" } displayType={ "mixed" }/>
			</div>
		)
		return (
			<div className="container AdminRosteringPage">
				<header className="pageHeader">
					<h1>Scratch Page</h1>
					{ dropdownDisplay }
				</header>
			</div>
		);
	}

	componentDidMount() {
		this.props.populateData()
	}
}

AdminRosteringPage.propTypes = PageStrictPropTypes({
	populateData: PropTypes.func
});

var ALL_CLASSES_FAKE_ID = -999;

module.exports = AdminRosteringPage;


// WEBPACK FOOTER //
// ./modules/components/org/roster/AdminRosteringPage.js